// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"54d684da","301":"3c7354ff"}[chunkId] + ".chunk.js";
};